export default {
  REGISTERED_IN_SLOVENIA: "registeredInSlovenia",
  REGISTERED_ABROAD: "registeredAbroad",
  COMPANY_VEHICLE: "companyVehicle",
  NOT_REGISTERED: "notRegistered",
  UNKNOWN: "unknown",
}